import styled from '@emotion/styled';

export const Group = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: ${({ theme }) => theme.spacings[1]};
  margin-right: ${({ theme }) => theme.spacings[4]};

  ${({ theme }) => theme.media.mobile} {
    margin-right: ${({ theme }) => theme.spacings[2]};
  }
`;

/* Sizes are fixed px so the control keeps the header layout stable while it is
   itself scaling the rest of the page's rem-based text. */
export const SizeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  padding: 0 6px;
  font-family: inherit;
  font-size: 15px;
  font-weight: bold;
  line-height: 1;
  cursor: pointer;
  border-radius: 8px;
  border: 2px solid ${({ theme }) => theme.colors.neutralMain};
  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.neutralMain : theme.colors.white};
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.white : theme.colors.neutralMain};

  ${({ theme }) => theme.media.mobile} {
    min-width: 34px;
    height: 34px;
    font-size: 13px;
  }
`;
